export function getNodeFromValue(value) {
  return value.startBlock
}

export function getRootBlock(value, node) {
  if (!value) return
  if (!value.document) return
  if (!node) return value.document.nodes.first()

  return value.document.getFurthestAncestor(node.key)
}
